import { render } from "./Matrix_Connections_includeMother.vue?vue&type=template&id=a4767778"
import script from "./Matrix_Connections_includeMother.vue?vue&type=script&lang=js"
export * from "./Matrix_Connections_includeMother.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__